import React, { useState, useEffect, useContext } from "react"
import request from "request"

import { ApplicationContext } from "ApplicationContext"
import Header from "Header"
import Table from "Table"
import AsyncContainer from "AsyncContainer"
import Button from "Button"
import Icon from "Icon"
import TerminalReassignModal from "components/TerminalReassignModal"

const TerminalsList = () => {
  const { CurrentUserContext } = useContext(ApplicationContext)
  const { venue: currentVenue } = CurrentUserContext
  const [isLoaded, setIsLoaded] = useState(false)
  const [terminals, setTerminals] = useState([])
  const [reassigningId, setReassigningId] = useState(null)
  const [stores, setStores] = useState([])

  const TERMINAL_HEADERS = {
    terminalName: "Terminal Name",
    authCode: "Auth Code",
    printer: "Printer?",
    reassign: "Reassign",
  }

  const TERMINAL_FORMATTERS = {
    terminalName: (t) => [ t.store?.name, t.number ].join(" Terminal "),
    printer: (t) => t.hasPrinter ? "Yes" : "No",
    reassign: (t) => <Button text={<Icon icon="redo" />} color="blue" onClick={() => setReassigningId(t.id)} />,
  }

  let reassignmentTerminal = terminals.find((t) => t.id === reassigningId)

  const reloadTerminals = () => {
    const req = request.get("terminals")
    req.then(({ data }) => {
      setTerminals(data.terminals)
      setIsLoaded(true)
    })
  }

  useEffect(() => {
    if(!!reassigningId) return
    reloadTerminals()
  }, [reassigningId])

  useEffect(() => {
    const req = request.get("/venue_admin/stores")
    req.then(({ data }) => setStores(data.stores))
  }, [currentVenue])


  if(currentVenue?.terminal == false) {
    return(
      <div>
        <Header text="Catch does Point of Sale!" />
        <div className="block" style={{textAlign: "center"}}>
          <p className="is-size-3">Looks like you're not using us for Point of Sale, so there's nothing here.</p>
          <p className="is-size-5">
            Want to hear more about Point of Sale at Catch?
            <br/>
            Reach out to us at <a href="mailto:sales@gocatch.io">sales@goatch.io</a> or your sales representative
          </p>
        </div>
      </div>
    )
  }

  return(
    <div>
      <Header text="Terminals" />
      <div className="block">
        <AsyncContainer isLoaded={isLoaded}>
          <Table
            rows={terminals}
            headers={TERMINAL_HEADERS}
            formatters={TERMINAL_FORMATTERS}
          />
        </AsyncContainer>
      </div>
      <TerminalReassignModal
        isOpen={!!reassigningId}
        onClose={() => {
          setReassigningId(null)
        }}
        stores={stores}
        terminal={reassignmentTerminal}
      />
    </div>
  )
}


export default TerminalsList
